import AltInstance from '../Globals/Scripts/AltInstance';
import MenuApi from '../Apis/MenuApi';
import ActionHelper from './ActionHelper';

class NavigationActions {
    constructor() {
        this.generateActions(
            'menuLoaded',
            'routeChanged',
            'navigated',
            'setPageTitle',
            'setPageHelpLink',
            'setBreadcrumbs',
            'originalEntityReady',
            'entityModified',
            'navigatedAway'
        );
    }

    async loadMenu() {
        var result = await ActionHelper.executeRequestWithNoActionNotification(MenuApi.loadMenu);
        this.menuLoaded(result);
    }
}

export default AltInstance.createActions(NavigationActions);
